module.exports = __webpack_public_path__ + "img/address.5d9146bc.png";